<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="mx-2 my-2 p-3" style="background-color: white; border-radius: 1rem;">
            <h1 class="title">User Login History</h1>
            <b-row>
                <b-col class="my-2 col-4 p-1" lg="3" md="4">
                    <b-form-group class="mb-0 ms-2 px-2">
                        <b-form-select :options="pageOptions" @change="handlePageSizeChange" class="col-md-4"
                            id="per-page-select" size="sm" v-model="perPage"></b-form-select>
                    </b-form-group>
                </b-col>
                <!--        search        -->
                <b-col class="my-2 col-4" lg="6" md="4"></b-col>
                <b-col class="my-2 col-4 p-1" lg="3" md="4">
                    <div class="d-flex flex-row align-items-center">
                        <b-input-group size="sm" class="me-2">
                            <b-form-input id="filter-input" placeholder="Type to Search" type="search"
                                v-model="filter"></b-form-input>
                        </b-input-group>
                        <button class="rounded btn-info me-4" @click="onFiltered">Search</button>
                    </div>

                </b-col>
            </b-row>
            <div v-if="loading">
                <div class="text-center mb-3 justify-content-between">
                    <b-spinner variant="primary"></b-spinner>
                </div>
            </div>
            <b-table v-else responsive striped bordered hover :items="items" :fields="fields" class="text-start">
                <template #cell(status)="row">
                    <div v-if="row.item.status == 'Y'">
                        <h5> <span class="badge bg-success">Active</span> </h5>
                    </div>
                    <div v-else>
                        <h5><span class="badge" style="background-color: indigo;">Inactive</span></h5>
                    </div>
                </template>
                <template #cell(login_time)="row">
                    <div>{{ row.item.login_time }} </div>
                </template>
                <template #cell(logout_time)="row">
                    <div v-if="row.item.logout_time">{{ row.item.logout_time }} </div>
                </template>
            </b-table>
            <b-row>
                <b-col class="mt-2" md="12" sm="12">
                    <b-pagination :per-page="perPage" :total-rows="totalRows" @click="handlePageChange" align="center"
                        class="my-0" v-model="currentPage" prev-text="Prev" next-text="Next"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import userHistoryService from '@/services/user-history.service.js';
import { notify } from "@kyvg/vue3-notification";
import moment from 'moment';

export default {
    data() {
        return {
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'User',
                    to: '/users/add'
                }, {
                    text: 'User Login History',
                    href: '#'
                }
            ],
            fields: [
                {
                    key: 'user_id_string',
                    label: 'User Id',
                    sortable: true
                },
                {
                    key: 'name',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'login_time',
                    label: 'Login Time',
                    sortable: true
                },
                {
                    key: 'logout_time',
                    label: 'Logout Time',
                    sortable: true
                },
                {
                    key: 'ip',
                    label: 'IP Address',
                    sortable: true
                },

                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },

            ],
            pageOptions: [5, 10, 20, 100],
            perPage: 5,
            currentPage: 1,
            filter: null,
            totalRows: 1,
            prevFilter: null,
            items: [],
            loading: false,
        }
    },
    created() {
        this.getPaginatedUserHistory();
    },
    methods: {
        async getPaginatedUserHistory() {
            const params = {
                'per_page': this.perPage,
                'page': this.currentPage,
                'search': this.filter,
            };
            var response;
            try {
                this.loading = true;
                response = await userHistoryService.getPaginatedUserHistory(params);
                this.loading = false;
            } catch (error) {
                this.loading = false;
                notify({
                    type: "error",
                    title: "User History",
                    text: error.response.data.message,
                });
            }
            if (response.data) {
                this.items = response.data.data.data;
                this.items.forEach(element => {
                    element.login_time = this.format_date(element.login_time);
                    element.logout_time = this.format_date(element.logout_time);
                });
                this.currentPage = response.data.data.current_page;
                this.totalRows = response.data.data.total;
                this.perPage = response.data.data.per_page;
            }
        },
        setStatusClass(value) {
            return value == "active" ? 'text-success' : 'text-danger';
        },
        format_date(value) {
            if (value) {
                return moment(String(value)).format('DD MMM,YYYY hh:mm a')
            }
        },
        handlePageSizeChange(value) {
            this.perPage = value;
            this.currentPage = 1;
            this.getPaginatedUserHistory();
        },
        onFiltered() {
            if (this.prevFilter != this.filter) {
                this.currentPage = 1
                this.getPaginatedUserHistory();
                this.prevFilter = this.filter;
            }
        },
        async handlePageChange() {
            await this.getPaginatedUserHistory();
        },
    }
}
</script>

<style scoped>
.title {
    /* text-align: center; */
    margin-bottom: 20px;
}
</style>
